/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterCalculateExpenseExciseRequest,
  PresenterCalculateExpenseExciseResponse,
  PresenterDraftAssetFilterResponse,
  PresenterDraftFixedAssetDetailResponse,
  PresenterDraftFixedAssetListResponse,
  PresenterError,
  PresenterExpenseDetailResponse,
  PresenterExpenseFilterResponse,
  PresenterExpenseListResponse,
  PresenterExpenseResponse,
  PresenterIDResponse,
  PresenterImportStartDateResponse,
  PresenterResponse,
  PresenterSaveImportStartDateRequest,
  PresenterSusJournalAlertStatusResponse,
  PresenterSusJournalBranchSideDetailResponse,
  PresenterSusJournalFilterResponse,
  PresenterSusJournalListResponse,
  PresenterSusJournalRefreshResponse,
  PresenterUpsertExpenseRequest,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class SuspenseAccount<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Returns the office's draft fixed assets filtered by status and optional term_month_id. Columns mirror the FA-ledger view (horizontally scrollable per Figma). Total count is returned in meta.total; meta.total_unreflect carries the office-wide count of drafts still awaiting confirmation (台帳未反映 and 台帳削除).
   *
   * @tags suspense_account
   * @name GetSuspenseAccountDraftAssets
   * @summary List draft fixed assets
   * @request GET:/suspense_account/draft_assets
   */
  getSuspenseAccountDraftAssets = (
    query?: {
      /** Draft status (1=NotReflected, 2=Reflected, 3=DeletedFromLedger); multi */
      status?: number[];
      /** Asset-name substring match */
      name?: string;
      /** Free text over asset code, memo, and linked journal remark */
      keyword?: string;
      /** Filter by asset category; repeatable or comma-separated */
      asset_category_id?: number[];
      /** Filter by department BIID; repeatable or comma-separated */
      department_biid?: string[];
      /** Department record id from /filters (departments[].id); matched on acquired_at */
      department_id?: number[];
      /** Also match drafts with no department on their acquired_at (部門なし); ORed with department_biid/department_id */
      no_department?: boolean;
      /** Filter by project BIID; repeatable or comma-separated */
      project_biid?: string[];
      /** Acquired-at range start (YYYY-MM-DD, inclusive) */
      acquired_at_from?: string;
      /** Acquired-at range end (YYYY-MM-DD, inclusive) */
      acquired_at_to?: string;
      /** Usage-started-at range start (YYYY-MM-DD, inclusive) */
      usage_started_at_from?: string;
      /** Usage-started-at range end (YYYY-MM-DD, inclusive) */
      usage_started_at_to?: string;
      /** Net (tax-exclusive) acquisition cost range start, inclusive */
      acquisition_cost_from?: number;
      /** Net (tax-exclusive) acquisition cost range end, inclusive */
      acquisition_cost_to?: number;
      /** Filter by area BIID */
      area_biid?: string;
      /** Term-month id filter (omitted = all term months) */
      term_month_id?: number;
      /** Sort: acquired_at, -acquired_at, journal_number, -journal_number (default: newest first) */
      sort?: string;
      /** Page number (1-based; default 1) */
      "page[number]"?: number;
      /** Page size (default 50) */
      "page[size]"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterDraftFixedAssetListResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/draft_assets`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the distinct asset categories, departments and projects present across the office's draft assets, resolved to labels for FE filter binding. Optionally scoped by status and term_month_id — the list's own row-scoping params — so the pickers describe the same rows the list shows. Filter params are deliberately not accepted: options that narrowed as the user selected would leave a multi-select impossible to widen. Note that projects[] carries only biid: code and name are always empty, because the project name is denormalized onto each draft row and the list response already has it.
   *
   * @tags suspense_account
   * @name GetSuspenseAccountDraftAssetsFilters
   * @summary Draft asset filter values
   * @request GET:/suspense_account/draft_assets/filters
   */
  getSuspenseAccountDraftAssetsFilters = (
    query?: {
      /** Draft status scope: 1=NotReflected, 2=Reflected, 3=DeletedFromLedger (omitted = all) */
      status?: number;
      /** Term-month id scope (omitted = all term months) */
      term_month_id?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterDraftAssetFilterResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/draft_assets/filters`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the office-scoped draft FA with status=NotReflected
   *
   * @tags suspense_account
   * @name GetSuspenseAccountDraftAssetsById
   * @summary Get draft fixed asset detail
   * @request GET:/suspense_account/draft_assets/{id}
   */
  getSuspenseAccountDraftAssetsById = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterDraftFixedAssetDetailResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/draft_assets/${id}`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the office's expenses (status omitted = all), filterable by keyword (Transfer-From No. and Transfer-To / Transfer-From remarks), term_month_id, journal_id (the expenses that contributed to one generated expense transfer journal — an unknown or stale id simply matches nothing), amount_from / amount_to (inclusive bounds on the expense amount; either may be omitted), and the Transfer-To / Transfer-From master ids (multi-select, AND-combined). Each row is a full mirror of the expense entity (+ resolved account/sub/department code+name) with its linked source sides nested under journal_allocations[].side (which in turn nests its owning branch under side.branch, and that branch's journal header under side.branch.sus_journal). Total in meta.total.
   *
   * @tags suspense_account
   * @name GetSuspenseAccountExpenses
   * @summary List expense targets (費用化対象)
   * @request GET:/suspense_account/expenses
   */
  getSuspenseAccountExpenses = (
    query?: {
      /** Status filter (1=未確定, 2=確定済; omitted = all) */
      status?: number;
      /** Free-text match against 摘要 (remark) */
      keyword?: string;
      /** Term-month id filter (omitted = all term months) */
      term_month_id?: number;
      /** Minimum expense amount (inclusive) */
      amount_from?: number;
      /** Maximum expense amount (inclusive) */
      amount_to?: number;
      /** Generated journal id filter (returns the expenses that contributed to that journal) */
      journal_id?: number;
      /** Transfer-To account item id filter */
      transfer_to_account_item_id?: number[];
      /** Transfer-To account sub item id filter */
      transfer_to_account_sub_item_id?: number[];
      /** Transfer-To department biid filter */
      transfer_to_department_biid?: string[];
      /** Transfer-To dept record id (/filters) by transaction_date */
      transfer_to_department_id?: number[];
      /** Transfer-To project biid filter */
      transfer_to_project_biid?: string[];
      /** Transfer-To business partner id filter */
      transfer_to_business_partner_id?: number[];
      /** Also match expenses with no Transfer-To sub account item (補助科目なし) */
      transfer_to_no_account_sub_item?: boolean;
      /** Also match expenses without a Transfer-To department on transaction_date (部門なし) */
      transfer_to_no_department?: boolean;
      /** Also match expenses with no Transfer-To project (プロジェクトなし) */
      transfer_to_no_project?: boolean;
      /** Also match expenses with no Transfer-To business partner (取引先なし) */
      transfer_to_no_business_partner?: boolean;
      /** Transfer-From (linked side) account item id filter */
      transfer_from_account_item_id?: number[];
      /** Transfer-From (linked side) sub item id filter */
      transfer_from_sub_item_id?: number[];
      /** Transfer-From (linked side) AccPlus dept id filter */
      transfer_from_dept_id?: number[];
      /** Saved Transfer-From AccPlus dept version (/filters key) */
      transfer_from_dept_key?: string[];
      /** Transfer-From (linked side) project biid filter */
      transfer_from_project_biid?: string[];
      /** Transfer-From (linked side) business partner id filter */
      transfer_from_business_partner_id?: number[];
      /** Sort by [-]journal_number, [-]transaction_date, or [-]recognized_at; '-' means DESC */
      sort?: string;
      /** Page number (1-based) */
      "page[number]"?: number;
      /** Page size */
      "page[size]"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterExpenseListResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/expenses`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Organizes one or more suspense-journal sides as a single expense (合算 supported). Status 未確定.
   *
   * @tags suspense_account
   * @name PostSuspenseAccountExpenses
   * @summary Create an expense target (費用化対象)
   * @request POST:/suspense_account/expenses
   */
  postSuspenseAccountExpenses = (
    body: PresenterUpsertExpenseRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterExpenseResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/expenses`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Compute-only: returns the inherited 税区分 and the 消費税額 for the given (side, amount) assignments without persisting anything. Business rules are NOT enforced here — a mismatched excise type, an over-allocation, or a closed month all still return 200; only Save rejects them. An unresolvable side_id is a 400. Pass expense_id (and allocation_id per assignment) on the Edit screen so the expense's own current allocations are released before computing what remains of each side.
   *
   * @tags suspense_account
   * @name PostSuspenseAccountExpensesCalculateExcise
   * @summary Preview the 消費税額 for a proposed expense assignment set
   * @request POST:/suspense_account/expenses/calculate_excise
   */
  postSuspenseAccountExpensesCalculateExcise = (
    body: PresenterCalculateExpenseExciseRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterCalculateExpenseExciseResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/expenses/calculate_excise`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the distinct master values present across the office's expenses, resolved to {id, code, name} (for FE filter binding). Optionally scoped to journal_id — the expenses that contributed to one generated expense transfer journal — so the picker options can be narrowed to a single journal's drill-down screen (an unknown or stale id simply yields empty option lists).
   *
   * @tags suspense_account
   * @name GetSuspenseAccountExpensesFilters
   * @summary Expense filter values
   * @request GET:/suspense_account/expenses/filters
   */
  getSuspenseAccountExpensesFilters = (
    query?: {
      /** Status scope (1=未確定, 2=確定済; omitted = all) */
      status?: number;
      /** Term-month id scope (omitted = all term months) */
      term_month_id?: number;
      /** Generated journal id scope (returns the filter values for the expenses that contributed to that journal) */
      journal_id?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterExpenseFilterResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/expenses/filters`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Returns a full mirror of the expense entity (+ resolved account/sub/department code+name) with its linked source sides nested under journal_allocations[].side (which in turn nests its owning branch under side.branch, and that branch's journal header under side.branch.sus_journal), and an editable flag (false when the month is closed).
   *
   * @tags suspense_account
   * @name GetSuspenseAccountExpensesById
   * @summary Get an expense target (edit screen)
   * @request GET:/suspense_account/expenses/{id}
   */
  getSuspenseAccountExpensesById = (id: number, params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterExpenseDetailResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/expenses/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Updates the header and/or the linked allocation set. Editing a 確定済 expense resets it to 未確定.
   *
   * @tags suspense_account
   * @name PutSuspenseAccountExpensesById
   * @summary Update an expense target
   * @request PUT:/suspense_account/expenses/{id}
   */
  putSuspenseAccountExpensesById = (
    id: number,
    body: PresenterUpsertExpenseRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterExpenseResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/expenses/${id}`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Reverts every linked allocation (restoring source-side unprocessed amount) and deletes the expense.
   *
   * @tags suspense_account
   * @name DeleteSuspenseAccountExpensesById
   * @summary Delete an expense target
   * @request DELETE:/suspense_account/expenses/{id}
   */
  deleteSuspenseAccountExpensesById = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterIDResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/expenses/${id}`,
      method: "DELETE",
      ...params,
    });
  /**
   * @description Returns all already-imported AccPlus journal branch sides for the office. selected_month is optional: when provided, a side is listed for that month until it is fully processed, i.e. while its fully_processed_term_month_end_date is empty or on/after the month start (the start date of the term month labeled by the selected year-month). Sides fully processed before the month start are hidden. A month with no term month falls back to the current monthly closing's start, and the journal's fetch_term_month_start_date is not used for filtering. When omitted the endpoint returns everything for the office (subject to paging and journal_ids). last_fetched_at is included so the FE can render the "最終取得日時" label. Each side carries account_item_id / account_sub_item_id (AccPlus account/sub-account IDs) alongside account_name / account_code / sub_account_name / sub_account_code. dept_name / dept_code are the AccPlus department as saved when the journal was fetched (AccPlus is only called, by dept_id, for sides fetched before that snapshot existed); aa_dept_biid / aa_dept_code / aa_dept_name are the mapped AA department (resolved from the local departments table via ref_id = dept_id). Both are omitted when the side has no dept or no matching department is found.
   *
   * @tags suspense_account
   * @name GetSuspenseAccountJournalBranchSides
   * @summary List suspense-account journals
   * @request GET:/suspense_account/journal_branch_sides
   */
  getSuspenseAccountJournalBranchSides = (
    query?: {
      /** Optional month guard, YYYY-MM; omit to return all */
      selected_month?: string;
      /** Page number (1-based; default 1) */
      "page[number]"?: number;
      /** Page size (default/max 2000) */
      "page[size]"?: number;
      /** Optional sus_journal IDs filter; omit to return all */
      journal_ids?: number[];
      /** Free-text match against journal number (when all digits) and/or remark */
      keyword?: string;
      /** Start transaction date (inclusive), YYYY-MM-DD */
      recognized_at_from?: string;
      /** End transaction date (inclusive), YYYY-MM-DD */
      recognized_at_to?: string;
      /** processed and/or unprocessed */
      processing_status?: string[];
      /** true and/or false; omit or both = no alert predicate */
      is_alert?: string[];
      /** Raw AccPlus journal type filter */
      journal_type?: string[];
      /** 登録方法: payable, pjc, bakuraku, import and/or other */
      registration_method?: string[];
      /** Account item id filter */
      account_item_id?: number[];
      /** Account sub item id filter */
      account_sub_item_id?: number[];
      /** AccPlus department id filter */
      dept_id?: number[];
      /** Saved AccPlus department version (departments[].key from /filters) */
      dept_key?: string[];
      /** AA department biid filter */
      aa_dept_biid?: string[];
      /** Project biid filter */
      project_biid?: string[];
      /** Business partner id filter */
      business_partner_id?: number[];
      /** Also match sides with no sub account item (補助科目なし); ORed with account_sub_item_id */
      no_account_sub_item?: boolean;
      /** Also match sides with no AccPlus department (部門なし); ORed with dept_id/dept_key/aa_dept_biid */
      no_dept?: boolean;
      /** Also match sides with no project (プロジェクトなし); ORed with project_biid */
      no_project?: boolean;
      /** Also match sides with no business partner (取引先なし); ORed with business_partner_id */
      no_business_partner?: boolean;
      /** debit and/or credit */
      side_type?: string[];
      /** Minimum side amount magnitude (inclusive) */
      amount_from?: number;
      /** Maximum side amount magnitude (inclusive) */
      amount_to?: number;
      /** Minimum unprocessed amount magnitude (inclusive) */
      unprocessed_amount_from?: number;
      /** Maximum unprocessed amount magnitude (inclusive) */
      unprocessed_amount_to?: number;
      /** journal_number, -journal_number, recognized_at, -recognized_at */
      sort?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterSusJournalListResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/journal_branch_sides`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns { has_alert: true } when at least one active branch side has an alert.
   *
   * @tags suspense_account
   * @name GetSuspenseAccountJournalBranchSidesAlertStatus
   * @summary Report whether the office has any alert/mismatch on journal branch sides
   * @request GET:/suspense_account/journal_branch_sides/alert_status
   */
  getSuspenseAccountJournalBranchSidesAlertStatus = (
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterSusJournalAlertStatusResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/journal_branch_sides/alert_status`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the distinct account items (nesting only the sub items that appear on a side), AccPlus departments, AA departments, projects, and business partners found on the office's journal branch sides, resolved to {id, code, name} for FE filter binding. An id the master service could not resolve is still returned, with empty code/name.
   *
   * @tags suspense_account
   * @name GetSuspenseAccountJournalBranchSidesFilters
   * @summary Journal branch side filter values
   * @request GET:/suspense_account/journal_branch_sides/filters
   */
  getSuspenseAccountJournalBranchSidesFilters = (
    query?: {
      /** Optional month guard, YYYY-MM; omit to scan all imported months */
      selected_month?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterSusJournalFilterResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/journal_branch_sides/filters`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the side aggregate and all active allocations owned by the side.
   *
   * @tags suspense_account
   * @name GetSuspenseAccountJournalBranchSidesById
   * @summary Get journal branch side detail with allocations
   * @request GET:/suspense_account/journal_branch_sides/{id}
   */
  getSuspenseAccountJournalBranchSidesById = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterSusJournalBranchSideDetailResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/journal_branch_sides/${id}`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags suspense_account
   * @name PutSuspenseAccountJournalBranchSidesByIdDismissAlert
   * @summary Dismiss alert for a journal branch side
   * @request PUT:/suspense_account/journal_branch_sides/{id}/dismiss_alert
   */
  putSuspenseAccountJournalBranchSidesByIdDismissAlert = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<PresenterResponse, PresenterError>({
      path: `/suspense_account/journal_branch_sides/${id}/dismiss_alert`,
      method: "PUT",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Refresh suspense-account journals from AccPlus
   *
   * @tags suspense_account
   * @name PostSuspenseAccountJournalsRefresh
   * @summary Refresh suspense-account journals from AccPlus
   * @request POST:/suspense_account/journals/refresh
   */
  postSuspenseAccountJournalsRefresh = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterSusJournalRefreshResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/journals/refresh`,
      method: "POST",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the current office's import settings (import_start_date).
   *
   * @tags suspense_account
   * @name GetSuspenseAccountSettingsImportStartDate
   * @summary Get suspense-account import settings
   * @request GET:/suspense_account/settings/import_start_date
   */
  getSuspenseAccountSettingsImportStartDate = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterImportStartDateResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/settings/import_start_date`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Upsert the office's import_start_date. Returns the persisted setting.
   *
   * @tags suspense_account
   * @name PostSuspenseAccountSettingsImportStartDate
   * @summary Save suspense-account import start date
   * @request POST:/suspense_account/settings/import_start_date
   */
  postSuspenseAccountSettingsImportStartDate = (
    body: PresenterSaveImportStartDateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterImportStartDateResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/settings/import_start_date`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
